var map = {
	"./photo1.jpg": 2098,
	"./photo10.jpg": 8512,
	"./photo11.jpg": 733,
	"./photo12.jpg": 4802,
	"./photo13.jpg": 6511,
	"./photo14.jpg": 5076,
	"./photo15.jpg": 9409,
	"./photo16.jpg": 1654,
	"./photo17.jpg": 4787,
	"./photo18.jpg": 7947,
	"./photo2.jpg": 589,
	"./photo3.jpg": 7136,
	"./photo4.jpg": 1939,
	"./photo5.jpg": 7238,
	"./photo6.jpg": 5009,
	"./photo7.jpg": 132,
	"./photo8.jpg": 8135,
	"./photo9.jpg": 9130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3172;